export default __webpack_public_path__ + "dc439b0477198374390513aa39722049.png";